<template>
  <v-app>
    <v-navigation-drawer v-if="isLoggedIn" v-model="drawer" app dark>
      <v-list>
        <v-list-item
          v-for="(item, index) in leftNavItems"
          :key="index"
          link
          @click="goto(item.path)"
        >
          <v-list-item-icon class="d-flex">
            <v-icon class="mr-auto ml-auto" size="20">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.label }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dark>
      <v-btn v-if="isLoggedIn" icon @click="drawer = !drawer">
        <v-icon>fa-bars</v-icon>
      </v-btn>
      <div
        class="d-flex align-center display-1 cursor-pointer mr-5"
        @click="goto('/')"
      >
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="/logo.png"
          transition="scale-transition"
          width="100"
        />
        <div v-if="!isSmallDevice">Reservation</div>
      </div>
      <v-spacer></v-spacer>
      <span v-if="isLoggedIn">{{ loggedUser }}</span>
      <v-btn
        class="mx-2"
        color="primary"
        v-if="isLoggedIn"
        to="/Account/ChangePassword"
        >Zamień hasło</v-btn
      >
      <v-btn class="mr-2" icon @click="toggleDark">
        <v-icon v-if="$store.getters.isDark">fa-moon</v-icon>
        <v-icon v-else>fa-sun</v-icon>
      </v-btn>
      <v-btn v-if="!isLoggedIn" color="primary" to="/login">Zaloguj</v-btn>
      <v-btn v-else color="error" @click="logout">Wyloguj</v-btn>
    </v-app-bar>
    <v-main>
      <v-container class="h-100" fluid>
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
    <v-overlay :value="loading" z-index="9999">
      <v-progress-circular color="black" indeterminate size="120">
        <v-img src="/logo.png" width="100"></v-img>
      </v-progress-circular>
    </v-overlay>
    <notify></notify>
  </v-app>
</template>

<script>
import { getTokenData } from "@/helpers";
export default {
  name: "App",
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isSmallDevice() {
      return this.windowWidth < 600;
    },
    loggedUser() {
      if (!this.isLoggedIn) {
        return "";
      }

      return getTokenData().userName;
    },
  },
  data: () => ({
    windowWidth: window.innerWidth,
    drawer: true,
    leftNavItems: [
      { icon: "fa-chart-line", path: "/", label: "Dashboard" },
      { icon: "fa-users", path: "/users", label: "Użytkownicy" },
      { icon: "fa-building", path: "/Companies", label: "Wdrożenia" },
      { icon: "fa-envelope", path: "/Mails", label: "Poczta" },
      {
        icon: "fa-ban",
        path: "/CancelReservations",
        label: "Anulowanie rezerwacji",
      },
      {
        icon: "fa-lock-open",
        path: "/GlobalWhiteList",
        label: "Zaufane IP",
      },
      { icon: "fa-flag", path: "/Locales", label: "Języki" },
      { icon: "fa-tasks", path: "/HangFire", label: "HangFire" },
      { icon: "fa-hashtag", path: "/Swagger", label: "Swagger" },
    ],
  }),
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    goto(path) {
      this.$router.push({ path: path });
    },
    toggleDark() {
      this.$store.dispatch("toggleDark");
      this.$vuetify.theme.dark = this.$store.getters.isDark;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
  /* transition-delay: .2s; */
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
  position: absolute;
  transform: translateX(-100vw);
  opacity: 0.5;
}

.slide-fade-leave-to {
  position: absolute;
  transform: translateX(100vw);
  opacity: 0.5;
}
</style>
